import {
  Baby,
  Bell,
  Blocks,
  BookOpen,
  BrushCleaning,
  CalendarDays,
  Camera,
  Car,
  Church,
  ClipboardList,
  Coffee,
  Cross,
  DoorOpen,
  Drum,
  Film,
  Flame,
  Gift,
  Globe,
  GraduationCap,
  Guitar,
  HandCoins,
  HandHelping,
  Handshake,
  Headphones,
  Heart,
  HeartPulse,
  House,
  Image,
  Lightbulb,
  type LucideIcon,
  Megaphone,
  MessageSquare,
  Mic,
  Monitor,
  Music,
  Palette,
  Radio,
  Shield,
  Smartphone,
  Smile,
  Sparkles,
  Speaker,
  Star,
  Users,
  UtensilsCrossed,
  Video,
} from 'lucide-react';

import { toneStyle } from '@/design-system/lib/tone';
import { paletteOf } from '@escala/domain/palette';
import type { Ministry, MinistryIconKey } from '@escala/domain/types';

/**
 * Desenho (lucide-react) de cada chave de ícone de ministério — a tabela do handoff e os
 * ícones novos dos modelos de ministério.
 */
export const MINISTRY_ICON_COMPONENTS: Record<MinistryIconKey, LucideIcon> = {
  door: DoorOpen,
  users: Users,
  home: House,
  heart: Heart,
  music: Music,
  mic: Mic,
  speaker: Speaker,
  monitor: Monitor,
  video: Video,
  camera: Camera,
  msg: MessageSquare,
  smile: Smile,
  star: Star,
  book: BookOpen,
  flame: Flame,
  cross: Cross,
  globe: Globe,
  gift: Gift,
  coffee: Coffee,
  utensils: UtensilsCrossed,
  shield: Shield,
  car: Car,
  palette: Palette,
  health: HeartPulse,
  calendar: CalendarDays,
  guitar: Guitar,
  drum: Drum,
  headphones: Headphones,
  radio: Radio,
  film: Film,
  image: Image,
  smartphone: Smartphone,
  megaphone: Megaphone,
  church: Church,
  bell: Bell,
  handshake: Handshake,
  helping: HandHelping,
  baby: Baby,
  blocks: Blocks,
  graduation: GraduationCap,
  coins: HandCoins,
  clipboard: ClipboardList,
  broom: BrushCleaning,
  lightbulb: Lightbulb,
  sparkles: Sparkles,
};

export default function MinistryIcon({ icon, className }: { icon: MinistryIconKey; className?: string }) {
  const Icon = MINISTRY_ICON_COMPONENTS[icon] ?? Users;

  return <Icon aria-hidden className={className} />;
}

/** A opção de um select de ministérios: o ícone e a cor do ministério antes do nome. */
export function ministryOption(ministry: Pick<Ministry, 'id' | 'name' | 'icon' | 'color'>) {
  return {
    value: ministry.id,
    label: ministry.name,
    icon: MINISTRY_ICON_COMPONENTS[ministry.icon] ?? Users,
    iconClassName: 'text-tone',
    iconStyle: toneStyle(paletteOf(ministry.color)),
  };
}
